import { Textarea, TextareaProps } from '@chakra-ui/react';
import React from 'react';

export const CmTextarea: React.FC<TextareaProps> = ({
  display = 'block',
  ...rest
}) => {
  // @ts-ignore TS2590
  return <Textarea {...{ ...rest, display }} />;
};
